import React from 'react'
export function AvaterDef(props){
    return (
        props.firstName && props.lastName ?
        <div className="width-100 height-100 dis-flex content-center item-center">
            {props.firstName[0].toUpperCase()+props.lastName[0].toUpperCase()}
        </div> : ''
    )
}